module.exports = __webpack_public_path__ + "img/tablet_deteriorating.3de435c2.jpg";